import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {defaultTemplate} from 'core/hoc';

class BaasicTableRowDetailTemplate extends Component {
    render() {
        return (
            <div>
                {JSON.stringify(this.props.dataItem)}
            </div>
        )
    }
}

BaasicTableRowDetailTemplate.propTypes = {
    dataItem: PropTypes.object.isRequired,
    t: PropTypes.any
};

export default defaultTemplate(BaasicTableRowDetailTemplate);
